import { message } from 'antd';
import { history } from '@umijs/max';
import { clearAuthData, removeToken, getAccessToken } from './auth';

/**
 * 统一的401未授权错误处理函数
 * 清除认证数据并跳转到登录页面
 */
export const handleUnauthorizedError = (customMessage?: string) => {
  // 清除认证数据
  clearAuthData();
  const accessToken = getAccessToken();
  if (accessToken) {
    // 显示提示信息
    const errorMessage = customMessage || '登录已过期，请重新登录';
    message.error(errorMessage);
    removeToken();
  }
  // 跳转到登录页面
  history.push('/login');
};

/**
 * 检查响应数据中是否包含401错误码
 * 支持多种数据结构：
 * 1. { code: 401, ... }
 * 2. { ret: { code: 401, ... }, ... }
 * 3. { data: { code: 401, ... }, ... }
 */
export const checkUnauthorizedError = (data: any): boolean => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  // 检查直接返回code=401的情况
  if ('code' in data && data.code === 401) {
    return true;
  }
  
  // 检查嵌套在ret对象中的code=401情况
  if ('ret' in data && data.ret && typeof data.ret === 'object' && 'code' in data.ret) {
    if (data.ret.code === 401) {
      return true;
    }
  }
  
  // 检查嵌套在data对象中的code=401情况
  if ('data' in data && data.data && typeof data.data === 'object' && 'code' in data.data) {
    if (data.data.code === 401) {
      return true;
    }
  }

  return false;
};

/**
 * 处理API响应中的401错误
 * 如果检测到401错误，自动处理并返回true
 * 如果没有401错误，返回false
 */
export const handleApiResponse = (data: any, customMessage?: string): boolean => {
  if (checkUnauthorizedError(data)) {
    handleUnauthorizedError(customMessage);
    return true;
  }
  return false;
};
